import colors from '../assets/styles/globals.scss'

export function checkLicensePermission(license, permittedLicenses) {
  return permittedLicenses.includes(license)
}

// Returns an i18n key (or undefined for an unknown license); callers wrap with t().
export function licenseLabel(license) {
  switch (license) {
    case 'standard':
      return 'communities.license.standard'
    case 'revenue_share':
      return 'communities.license.partnerPlan'
    case 'standard_legacy':
      return 'communities.license.standardLegacy'
    // no default
  }
}

export function licenseColor(license) {
  switch (license) {
    case 'standard':
      return colors.primaryTeal
    case 'revenue_share':
      return colors.primaryBlue
    case 'standard_legacy':
      return colors.secondaryColor
    // no default
  }
}
